import { dialogDefault, DIALOG_GOAL } from "../consts";

const mydialog = {...dialogDefault}


export const goalDialogAction = ({ open = false, id = 0  }) => ({
    type: DIALOG_GOAL,
    payload : { open, id  }
});

export default function goalDialogReducer(state = mydialog, { type, payload }) {

    const actions = {
        [DIALOG_GOAL] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}

